export const LOGIN_PAGE = "LOGIN_PAGE";
export const REGISTER_PAGE = "REGISTER_PAGE";
export const FORGOT_PASSWORD_PAGE = "FORGOT_PASSWORD_PAGE";
export const RESET_PASSWORD_REQUEST_PAGE = "RESET_PASSWORD_REQUEST_PAGE";
export const RESET_PASSWORD_PAGE = "RESET_PASSWORD_PAGE";
export const EMAIL_VERIFICATION = "EMAIL_VERIFICATION_PAGE";
export const ACCOUNT_INVITATION_PAGE = "ACCOUNT_INVITATION_PAGE";